/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpassword1Inputs */

const en_newpassword1 = /** @type {(inputs: Newpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Password`)
};

const de_newpassword1 = /** @type {(inputs: Newpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Passwort`)
};

/**
* | output |
* | --- |
* | "New Password" |
*
* @param {Newpassword1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const newpassword1 = /** @type {((inputs?: Newpassword1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpassword1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpassword1(inputs)
	return de_newpassword1(inputs)
});
export { newpassword1 as "newPassword" }